import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ImageMixin } from '../../mixins/components/ImageMixin';

/**
 * A simple `img` tag.
 *
 * @since 6.10.0
 */
var Image = /*#__PURE__*/styled.img.withConfig({
  displayName: "Image",
  componentId: "c11n-8-111-1__sc-1rtmhsc-0"
})(["", ""], ImageMixin);
Image.displayName = 'Image';
Image.propTypes = {
  /**
   * Images must have alt text or set this to empty string for
   * decorative images:
   * https://www.w3.org/WAI/tutorials/images/decorative/
   */
  alt: PropTypes.string.isRequired,
  /**
   * The image source.
   */
  src: PropTypes.string.isRequired
};

/** @component */
export { Image };